module.exports = __webpack_public_path__ + "assets/549e540aa8a183b05699b6615bf3bda2.jpg";